/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_PasteInputs */



/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Shortcut_Keys_Name_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_paste = /** @type {((inputs?: Shortcut_Keys_Name_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Paste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impasto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ペースト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar")
	return /** @type {LocalizedString} */ ("Paste")
});